/** @module csi/widget/ValidationTextBox */
define([
	"dojo/_base/declare",
	"dijit/form/ValidationTextBox",
	"./_ErrorMessageMixin",
	"csi/html",
	"dojo/text!./ValidationTextBox.html"
], function(declare,ValidationTextBox,_ErrorMessageMixin,html,template) {
	
	return declare([ValidationTextBox, _ErrorMessageMixin], {
		templateString: template,
		
		/** @property {boolean} bCounterVisible - set it to "false" to prevent counter showing up on non zero maxLength */ 
		bCounterVisible: true,
		
		/**
		 * Set visibility of character counter and update it
		 */
		postCreate: function(){
			html.setVisible(this.counterNode, this._isCounterVisible());
			this.inherited(arguments);
			this._updateCounter();
		},
		
		/**
		 * Update character counter on input event
		 * @param {Event} evt
		 */
		_onInput: function(evt){
			this.inherited(arguments);
			this._updateCounter();
		},

		/**
		 * Update character counter on value set
		 * @param {string} value
		 * @param {boolean} [priorityChange]
		 * @param {string} [formattedValue]
		 */
		_setValueAttr: function(value, priorityChange, formattedValue){
			this.inherited(arguments);
			this._updateCounter(value);
		},

		/**
		 * Update character counter
		 * @param {string} value
		 */
		_updateCounter: function(value){
			var val = value || this.textbox.value || "";
			if (this._isCounterVisible()){
				this.counterNode.innerText = val.length + "/" + this._getMaxLength();
			}
		},
		
		/**
		 * Returns maxLength of the control
		 * @return {Number}
		 */
		_getMaxLength: function(){
			var maxLen =  this.maxLength || this.textbox.maxLength;
			// IE returns 2147483647 (integer overflow) if max length is not set
			if ((maxLen < 0) || (maxLen > 99999)) {
				maxLen = 0;
			}
			return maxLen;
		},
		
		/**
		 * Determine if counter should be visible
		 * @return {boolean}
		 */
		_isCounterVisible: function(){
			return this.bCounterVisible && this._getMaxLength();
		}
	});
});
